function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.308C0 1.139.138 1 .334 1h15.332c.184 0 .334.148.334.308v.984c0 .17-.138.308-.334.308H.334C.15 2.6 0 2.452 0 2.292v-.983zm0 6.4c0-.17.138-.308.334-.308h15.332c.184 0 .334.148.334.308v.983c0 .17-.138.309-.334.309H.334C.15 9 0 8.852 0 8.691v-.983zm0 6.4c0-.17.138-.308.334-.308h15.332c.184 0 .334.148.334.308v.983c0 .17-.138.309-.334.309H.334C.15 15.4 0 15.252 0 15.091v-.982z",
  fill: "currentColor"
});

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBurger;